'use client';

import { styled } from '../../styles';
import { Typography } from '../Typography';

export const HeadCellTitle = styled(Typography)(() => ({
  whiteSpace: 'nowrap',
}));
